import { Modal } from 'pcln-modal'
import styled from 'styled-components'
import { theme } from 'pcln-design-system'

const StyledModal = styled(Modal)`
  overflow: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
  & * {
    box-sizing: border-box;
    -webkit-overflow-scrolling: auto;
  }
`

/* istanbul ignore next */
const SEARCH_DROPDOWN = (transitionState) => `
  transform: translateY(${transitionState === 'entered' ? `0px` : '-120%'});
  transition: transform ${theme.duration.normal} ease-out;
`

export { StyledModal, SEARCH_DROPDOWN }
